<template>
  <div class="wrapper" v-if="isdialogFormVisible">
    <el-dialog
      :title="dialogtitle"
      :visible.sync="dialogFormVisible"
      @close="dialogclose"
      destroy-on-close
      :width="width"
      :modal="false"
    >
      <el-form ref="form" :model="map_config_value" label-width="80px">
        <el-form-item label="地图主题">
          <el-select
            v-model="map_config_value.mapzhuti.lable"
            placeholder="主题"
            @change="getCouponSelected"
          >
            <el-option
              v-for="item in cities"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.value
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="3D效果">
          <el-switch v-model="map_config_value.delivery.value"></el-switch>
        </el-form-item>
        <el-form-item label="显示要素">
          <el-checkbox-group v-model="map_config_value.type.lable" >
            <el-checkbox v-for="item in mapconfing_1" :key="item.value" :label=item.lable name="type" @change="checkboxcheng(item)"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="图层类别">
          <el-radio-group v-model="map_config_value.mapType.lable">
            <el-radio v-for="item in mapconfing_2" :key="item.value" :label=item.lable @change="radiocheng(item)"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存配置</el-button>
          <el-button @click="dialogclose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import localStorage from '../../libs/js/localStorage.js'

export default {
  components: {},
  props: {
    isdialogFormVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    ishiddeCallBack: {
      type: Function
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    submitCallBack: {
      type: Function
    },

  },
  data() {
    return {
      dialogFormVisible: false,
      dialogtitle: "地图配置",
      lodeg_isbool: true,
      num: 1,
      mapconfing_1:[{
            lable:'区域面',
            value:'bg'
        },
        {
            lable:'道路',
            value:'road'
        },
        {
            lable:'建筑物',
            value:'building'
        },
        {
            lable:'标注',
            value:'point'
        }],
        mapconfing_2:[{
            lable:'标准地图',
            value:'normal'
        },
        {
            lable:'卫星地图',
            value:'satellite'
        },
        {
            lable:'行政地图',
            value:'administration'
        }],
      map_config_value:{
        mapzhuti:{
            lable:'推荐',
            value:'amap://styles/b1220e2e801fbd718425afa88df21dbb'
        },
        delivery:{
            value:false
        },
        type: {
            lable: ['区域面','道路','建筑物','标注'],
            value:["bg", "road", "building", "point"]
        },
        mapType:{
            lable:"标准地图",
            value:"normal"
        },
      },
      cities: [
        {
          value: "recommend",
          label: "推荐"
        },
        {
          value: "normal",
          label: "标准"
        },
        {
          value: "dark",
          label: "幻影黑"
        },
        {
          value: "light",
          label: "月光银"
        },
        {
          value: "whitesmoke",
          label: "远山黛"
        },
        {
          value: "fresh",
          label: "草色青"
        },
        {
          value: "grey",
          label: "雅士灰"
        },
        {
          value: "graffiti",
          label: "涂鸦"
        },
        {
          value: "macaron",
          label: "马卡龙"
        },
        {
          value: "blue",
          label: "靛青蓝"
        },
        {
          value: "darkblue",
          label: "极夜蓝"
        },
        {
          value: "wine",
          label: "酱籽"
        }
      ]
  };
  },
  watch: {
    isdialogFormVisible: {
      handler: function(newVal) {
        this.dialogFormVisible = newVal;
        var maptypedata = localStorage.getStore('map_data_Config')
        for (var item in maptypedata) {
          this.map_config_value[item] = maptypedata[item];
        }
        console.log('map_config_value',this.map_config_value)
      }
    }
  },
  computed: {},
  methods: {
    dialogclose() {
      this.$props.ishiddeCallBack();
    },
    getCouponSelected(item) {
      var str = item=='recommend'?'b1220e2e801fbd718425afa88df21dbb':item
      var styleName ="amap://styles/" + str;
      this.map_config_value.mapzhuti.value = styleName
    },
    checkboxcheng(item){
        
        var index = this.map_config_value.type.value.indexOf(item.value)
        if (index> -1) {
            this.map_config_value.type.value.splice(index,1);
        }else
        {
            this.map_config_value.type.value.push(item.value);
        }
        console.log(this.map_config_value.type.value);


    },
    radiocheng(item){
        console.log(item);
        this.map_config_value.mapType.value = item.value

    },
    onSubmit(){
        localStorage.setStore('map_data_Config', this.map_config_value)
        this.$props.submitCallBack()
        this.$props.ishiddeCallBack();



    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.qiehuan {
  position: relative;
  top: 65%;
}
.pics_group {
  padding: 10px 0 0 0;
  position: absolute;
  width: 71%;
  height: 52%;
  top: 10%;
  background-color: rgba(82, 231, 241, 0.3);
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

.bg-purple {
  background: #d3dce6;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.center_right {
  position: absolute;
  right: 1%;
  top: 8%;
  background-color: rgba(0, 0, 0, 0.3);
  width: 25%;
  height: 90%;
  padding: 0px 10px 0px 5px;
  overflow: auto;
  .el-col {
    margin-top: 10%;
  }
  .number {
    position: relative;
    color: greenyellow;
    top: -10px;
    left: 5%;
  }
  .center_right_imglog {
    width: 25px;
    height: 25px;
    float: left;
    position: relative;
  }
  .spantitle {
    color: wheat;
    margin-left: 5px;
  }
}

.content_detail {
  width: 100%;
  height: 26%;
  color: #ffffff;
  font-size: 12px;
  top: 70%;
  background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/detail_bottom.png)
    no-repeat;
  background-size: 100% 100%;
  background-size: contain;
  position: relative;

  .detai_box {
    padding: 20px 0 0 10px;
    position: absolute;
    width: 75%;
    .el-col {
      margin-top: 1.5%;
      margin-left: 2%;
    }

    .dian {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #08d320;
      margin-right: 10px;
    }
  }
}
& /deep/ .el-carousel__container {
  position: relative;
  width: 97%;
  left: 10px;
  right: 10px;
}
& /deep/ .el-dialog__title {
  color: rgb(146, 211, 241);

  text-align: center;
}
& /deep/ .el-dialog__header {
  background: url("https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/bg-min.png")
    no-repeat;
}
& /deep/ .el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  background: url("https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/bg-min.png")
    no-repeat;
  background-size: 100% 100%;

}

& /deep/ .el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

& /deep/ .el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

& /deep/ .el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
& /deep/ .el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
& /deep/ .el-dialog__header {
  padding: 20px 20px 10px;
  text-align: center;
}

& /deep/ .el-checkbox {
  color: #408cf0;
}
& /deep/.el-form-item__label {
  font-size: 14px;
  color: #f7f7f7;
}
& /deep/.el-radio {
  color: #408cf0;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog_map_style.vue